import { LiveSaleSummaryController } from "./live-sale-summary.controller";

angular
    .module("thor.sales.edit.live-sale-summary.component", [])
    .component("liveSaleSummary", {
        bindings: {
            liveOperators: "<",
            liveSale: "<",
            saleCurrency: "<",
            startAt: "<"
        },
        controller: LiveSaleSummaryController,
        template: require("./live-sale-summary.html")
    });
